export default (() => {

    const global = {
        elements: {},
        pageData: {},
        requestData: {}
    };

    function initialise (data) {
        _cacheDom();
        _cacheRequestData();
        _setPageData(data);
        _initialiseComponents();
        _bindEvents();

        _updateSelectedPortfolios();
        _setSummaryJISAs();

        if (!global.pageData.isSmsEnabled) {
            _setSummarySecurityMethodToPin();
        }
    }

    function _cacheDom () {

        // Inputs
        global.elements.firstName = document.querySelector('[data-first-name]');
        global.elements.lastName = document.querySelector('[data-last-name]');
        global.elements.email = document.querySelector('[data-email]');
        global.elements.relationship = document.querySelector('[data-relationship]');
        global.elements.message = document.querySelector('[data-message]');
        global.elements.mobileNumberTextbox = document.querySelector('[data-mobile-number-textbox]');
        global.elements.mobileUnknown = document.querySelector('[data-mobile-unknown]');

        // Callouts
        global.elements.mobileCallout = document.querySelector('[data-no-mobile-callout]');

        // Messages
        global.elements.selfEmailMessage = document.querySelector('[data-self-email-message]');

        // Buttons
        global.elements.securityModalButton = document.querySelector('[data-mobile-number-modal]');
        global.elements.sendInviteButton = document.querySelector('[data-send-invite]');

        // Modals
        global.elements.securityModal = document.querySelector('[data-security-modal]');
        global.elements.pendingInviteModal = document.querySelector('[data-pending-invite-modal]');
        global.elements.activeContributorModal = document.querySelector('[data-active-contributor-modal]');
        global.elements.inactiveContributorModal = document.querySelector('[data-inactive-contributor-modal]');
        global.elements.existingContributorModal = document.querySelector('[data-multiple-existing-contributors-modal]');

        // Toggles
        global.elements.jisaToggles = [...document.querySelectorAll('[data-jisa-toggle]')];

        // Summary
        global.elements.summaryName = document.querySelector('[data-summary-name]');
        global.elements.summaryEmail = document.querySelector('[data-summary-email]');
        global.elements.summaryJisas = document.querySelector('[data-summary-jisas]');
        global.elements.summaryMobile = document.querySelector('[data-summary-mobile]');

        // Summary labels
        global.elements.summaryNameLabelEmpty = document.querySelector('[data-summary-name-label-empty]');
        global.elements.summaryNameLabelPopulated = document.querySelector('[data-summary-name-label-populated]');
        global.elements.summaryEmailLabelEmpty = document.querySelector('[data-summary-email-label-empty]');
        global.elements.summaryEmailLabelPopulated = document.querySelector('[data-summary-email-label-populated]');
        global.elements.summaryMethodLabelEmpty = document.querySelector('[data-summary-method-label-empty]');
        global.elements.summaryMethodLabelPin = document.querySelector('[data-summary-method-label-pin]');
        global.elements.summaryMethodLabelSms = document.querySelector('[data-summary-method-label-sms]');

        // Previously invited modal data slugs
        global.elements.pendingInviteModalChildNames = document.querySelectorAll('[data-pending-invite-child-names]');
        global.elements.activeContributorModalChildNames = document.querySelectorAll('[data-active-contributor-child-names]');
        global.elements.inactiveContributorModalChildNames = document.querySelectorAll('[data-inactive-contributor-child-names]');
        global.elements.existingContributorModalContributorName = document.querySelector('[data-multiple-existing-contributor-name]');
        global.elements.multipleExistingPlanSingular = document.querySelector('[data-multiple-existing-plan-singular]');
        global.elements.multipleExistingPlanMultiple = document.querySelector('[data-multiple-existing-plan-multiple]');
        global.elements.multipleExistingPreviouslyInvited = document.querySelector('[data-multiple-existing-previously-invited]');
        global.elements.multipleExistingPreviouslyContributed = document.querySelector('[data-multiple-existing-previously-contributed]');
        global.elements.multipleExistingActivelyContributing = document.querySelector('[data-multiple-existing-actively-contributing]');

        // Previously invited modal buttons
        global.elements.pendingInviteModalSendAgain = document.querySelector('[data-pending-invite-modal-send-again]');
        global.elements.pendingInviteModalCancel = document.querySelector('[data-pending-invite-modal-cancel]');
        global.elements.activeContributorModalKeepEditing = document.querySelector('[data-active-contributor-modal-keep-editing]');
        global.elements.inactiveContributorModalSendAgain = document.querySelector('[data-inactive-contributor-modal-send-again]');
        global.elements.inactiveContributorModalCancel = document.querySelector('[data-inactive-contributor-modal-cancel]');
        global.elements.existingContributorModalContinue = document.querySelector('[data-multiple-existing-contributors-modal-continue]');
        global.elements.existingContributorModalCancel = document.querySelector('[data-multiple-existing-contributors-modal-cancel]');
    }

    function _cacheRequestData () {
        global.requestData.postUrl = document.querySelector('[data-send-invite-url]').getAttribute('data-send-invite-url');
        global.requestData.confirmUrl = document.querySelector('[data-confirm-url]').getAttribute('data-confirm-url');
        global.requestData.verifyEmailUrl = document.querySelector('[data-verify-email-url]').getAttribute('data-verify-email-url');
        global.requestData.planUrl = document.querySelector('[data-plan-url]').getAttribute('data-plan-url');
        global.requestData.cancelInvitesUrl = document.querySelector('[data-cancel-invites-url]').getAttribute('data-cancel-invites-url');
    }

    function _setPageData (data) {
        global.pageData = data;
        global.pageData.selectedPortfolios = [];
        global.pageData.emailVerificationModel = {};
    }

    function _bindEvents () {

        global.elements.firstName.addEventListener('valuechange', () => {
            _setSummaryName();
            _enableDisableSendInviteButton();
        });

        global.elements.lastName.addEventListener('valuechange', () => {
            _setSummaryName();
            _enableDisableSendInviteButton();
        });

        global.elements.email.addEventListener(global.elements.email.events.ValueChange.name, () => {
            _setSummaryEmail();
            _enableDisableSendInviteButton();
        });

        if (global.pageData.isSmsEnabled) {
            const mobileTextbox = global.elements.mobileNumberTextbox;
            
            mobileTextbox.addEventListener(mobileTextbox.events.ValueChange.name, () => {
                _setSummarySecurityMethod();
                _enableDisableSendInviteButton();
            });

            global.elements.mobileUnknown.addEventListener('change', () => {
                _setSummarySecurityMethod();
                _enableDisableSendInviteButton();
            });

            global.elements.securityModalButton.addEventListener('click', () => global.elements.securityModal.open = true) ;

        }

        global.elements.sendInviteButton.addEventListener('click',() => _verifyIfExistingContributorByEmail().then(response => _verifyIfExistingContributorByEmailCallback(response))); 

        global.elements.jisaToggles.forEach(toggle => {
            toggle.addEventListener('valuechange', () => {
                _updateSelectedPortfolios();
                _setSummaryJISAs();
                _enableDisableSendInviteButton();
            });
        });

        global.elements.pendingInviteModalCancel.addEventListener('click', () => global.elements.pendingInviteModal.open = false) ;

        global.elements.activeContributorModalKeepEditing.addEventListener('click', () => global.elements.activeContributorModal.open = false);

        global.elements.inactiveContributorModalCancel.addEventListener('click', () => global.elements.inactiveContributorModal.open = false);

        global.elements.existingContributorModalCancel.addEventListener('click', () => global.elements.existingContributorModal.open = false);

        global.elements.pendingInviteModalSendAgain.addEventListener('click', () => {
            global.elements.pendingInviteModalSendAgain.disabledProp = true;
            _cancelInvitesOfPreviouslyInvitedPortfolios();
            _sendInvitesWithoutActiveContributionOnly();
        });

        global.elements.inactiveContributorModalSendAgain.addEventListener('click', () => {
            global.elements.inactiveContributorModalSendAgain.disabledProp = true;
            _cancelInvitesOfPreviouslyInvitedPortfolios();
            _sendInvitesWithoutActiveContributionOnly();
        });

        global.elements.existingContributorModalContinue.addEventListener('click', () => {
            global.elements.existingContributorModalContinue.disabledProp = true;
            _cancelInvitesOfPreviouslyInvitedPortfolios();
            _sendInvitesWithoutActiveContributionOnly();
        });
    }

    function _initialiseComponents () {
        global.elements.relationship.items = global.pageData.customerRelationshipTypes.map(type => ({
            label: `I'm their ${type.Name}`,
            value: type.Id
        }));
    }

    function _setSummaryName () {
        const firstName = global.elements.firstName.value ?? '';
        const lastName = global.elements.lastName.value ?? '';
        const name = `${firstName} ${lastName}`;
        const hasName = name !== ' ';

        global.elements.summaryNameLabelEmpty.hidden = hasName;
        global.elements.summaryNameLabelPopulated.hidden = !hasName;

        global.elements.summaryName.innerHTML = hasName ? name : '';
    }

    function _setSummaryEmail () {
        const value = global.elements.email.value ?? '';
        const hasValue = value !== '';

        global.elements.summaryEmailLabelEmpty.hidden = hasValue;
        global.elements.summaryEmailLabelPopulated.hidden = !hasValue;

        global.elements.summaryEmail.innerHTML = value;
    }

    function _setSummarySecurityMethodToPin () {
        global.elements.summaryMethodLabelEmpty.hidden = true;
        global.elements.summaryMethodLabelPin.hidden = false;
    }

    function _setSummarySecurityMethod () {

        let calloutClassListAction = global.elements.mobileUnknown.checked ? 'remove' : 'add';
        const isMobileKnown = !global.elements.mobileUnknown.checked;
        const hasMobileNo = global.elements.mobileNumberTextbox.value !== '';

        global.elements.summaryMethodLabelEmpty.hidden = !isMobileKnown || hasMobileNo;

        global.elements.summaryMethodLabelPin.hidden = isMobileKnown;
        global.elements.mobileNumberTextbox.value = !isMobileKnown ? '' : global.elements.mobileNumberTextbox.value;
        global.elements.mobileNumberTextbox.disabledprop = !isMobileKnown;

        global.elements.summaryMethodLabelSms.hidden = !isMobileKnown || !hasMobileNo;
        global.elements.summaryMobile.hidden = !isMobileKnown || !hasMobileNo;
        global.elements.summaryMobile.innerHTML = global.elements.mobileNumberTextbox.value ?? '';
        global.elements.mobileCallout.classList[calloutClassListAction]('u-display__none');

        if (!isMobileKnown) {
            global.elements.mobileNumberTextbox.validation.events.StatusDismissAll.dispatch();
        }
    }

    function _setSummaryJISAs () {
        return global.elements.summaryJisas.innerHTML = _getCombinedChildNamesString();
    }

    function _enableDisableSendInviteButton () {

        const isNamePopulated = (global.elements.firstName.value ?? '') !== '' && (global.elements.lastName.value ?? '') !== '';
        const hasEmail = (global.elements.email.value ?? '') !== '' && global.elements.email.valid;
        const isSecurityMethodSelected = !global.pageData.isSmsEnabled || global.elements.mobileUnknown.checked || ((global.elements.mobileNumberTextbox.value ?? '') !== '' && global.elements.mobileNumberTextbox.valid);
        const isAJisaSelected = global.pageData.selectedPortfolios.length > 0;

        const isDisabled = !isNamePopulated || !hasEmail || !isSecurityMethodSelected || !isAJisaSelected;

        global.elements.sendInviteButton.disabledProp = isDisabled;
    }

    async function _sendInvitesWithoutActiveContributionOnly () {

        const isAssociatedToPortfolio = global.pageData.emailVerificationModel.AssociatedPortfolios.IsAssociated;
        const portfoliosToSendInviteTo = isAssociatedToPortfolio
            ? global.pageData.selectedPortfolios.filter(_filterPortfoliosRequiringNewInvite)
            : global.pageData.selectedPortfolios;
        const portfolioIds = portfoliosToSendInviteTo.map(portfolio => portfolio.portfolioId);

        if (portfolioIds.length === 0) {
            window.location = global.requestData.planUrl;
        }

        const config = {
            data: {
                FirstName: global.elements.firstName.value,
                Surname: global.elements.lastName.value,
                Message: global.elements.message.value,
                PhoneNumber: global.elements.mobileUnknown.checked ? '' : global.elements.mobileNumberTextbox.value,
                EmailAddress: global.elements.email.value,
                ContributorRelationshipTypeId: global.elements.relationship.selected !== '' ? global.elements.relationship.selected : null,
                PortfolioIds: portfolioIds
            },
            contentType: 'application/json',
            url: global.requestData.postUrl
        };

        wealthify.request.send(config).then((response) => {
            if (response) {
                window.location = `${global.requestData.confirmUrl}/${response}`;
            } else {
                window.location = global.requestData.planUrl;
            }
        });
    }

    async function _cancelInvitesOfPreviouslyInvitedPortfolios () {

        let invitesToCancel = [];

        for (const pendingInvite of global.pageData.emailVerificationModel.AssociatedPortfolios.PendingInvites) {
            const pendingInviteContainsSelectedPortfolio = global.pageData.selectedPortfolios.some(portfolio => pendingInvite.PortfolioIds.includes(portfolio.portfolioId));
            const pendingInviteAlreadyAdded = invitesToCancel.includes(pendingInvite.ContributorInviteId);

            if (pendingInviteContainsSelectedPortfolio && !pendingInviteAlreadyAdded) {
                invitesToCancel.push(pendingInvite.ContributorInviteId);
            }
        }

        if (invitesToCancel.length > 0) {
            const config = {
                data: { InvitesToCancel: invitesToCancel },
                contentType: 'application/json',
                url: global.requestData.cancelInvitesUrl,
            };

            wealthify.request.send(config);
        }
    }

    function _filterPreviouslyUnassociatedPortfolios (portfolio) {
        const hasPreviousInvite = global.pageData.emailVerificationModel.AssociatedPortfolios.PendingInvites.some(invite => invite.PortfolioIds.includes(portfolio.portfolioId));
        const hasActiveContribution = global.pageData.emailVerificationModel.AssociatedPortfolios.ActivelyContributingTo.includes(portfolio.portfolioId);
        const hasPreviouslyContributed = global.pageData.emailVerificationModel.AssociatedPortfolios.PreviouslyContributedTo.includes(portfolio.portfolioId);

        return !hasPreviousInvite && !hasActiveContribution && !hasPreviouslyContributed;
    }

    function _filterPortfoliosRequiringNewInvite (portfolio) {
        const hasActiveContribution = global.pageData.emailVerificationModel.AssociatedPortfolios.ActivelyContributingTo.includes(portfolio.portfolioId);

        return !hasActiveContribution;
    }

    function _verifyIfExistingContributorByEmail () {

        const config = {
            data: { email: global.elements.email.value },
            url: global.requestData.verifyEmailUrl,
            contentType: 'application/json'
        };

        global.elements.sendInviteButton.disabledProp = true;

        return wealthify.request.send(config);
    }

    function _verifyIfExistingContributorByEmailCallback (verificationModel) {

        global.pageData.emailVerificationModel = verificationModel;
        global.elements.sendInviteButton.disabledProp = false;

        const pendingInvitePortfolioIds = verificationModel.AssociatedPortfolios.PendingInvites.map(i => i.PortfolioIds).flat();
        const allAssociatedPortfolios = [...pendingInvitePortfolioIds, ...verificationModel.AssociatedPortfolios.ActivelyContributingTo, ...verificationModel.AssociatedPortfolios.PreviouslyContributedTo];
        const selectedPortfolioIds =  global.pageData.selectedPortfolios.map(portfolio => portfolio.portfolioId);
        const isAssociatedWithAnySelectedPortfolio = allAssociatedPortfolios.some(existing => selectedPortfolioIds.includes(existing));

        const callback = isAssociatedWithAnySelectedPortfolio ? _showExistingContributorModal : _sendInvitesWithoutActiveContributionOnly;

        if (verificationModel.IsOwnEmail) {
            const classListAction = verificationModel.IsOwnEmail ? 'remove' : 'add';

            global.elements.selfEmailMessage.classList[classListAction]('u-display__none');

            return;
        }

        callback();
    }

    function _showExistingContributorModal () {
        const associatedPortfolios = global.pageData.emailVerificationModel.AssociatedPortfolios;
        const previouslyInvited = global.pageData.selectedPortfolios.filter(portfolio => associatedPortfolios.PendingInvites.some(invite => invite.PortfolioIds.includes(portfolio.portfolioId)));
        const activelyContributing = global.pageData.selectedPortfolios.filter(portfolio => associatedPortfolios.ActivelyContributingTo.includes(portfolio.portfolioId));
        const previouslyContributed = global.pageData.selectedPortfolios.filter(portfolio => associatedPortfolios.PreviouslyContributedTo.includes(portfolio.portfolioId));
        const newlyInvited = global.pageData.selectedPortfolios.filter(_filterPreviouslyUnassociatedPortfolios);

        const scenariosMap = {
            resendInvites: {
                portfolios: previouslyInvited,
                elements: {
                    modal: global.elements.pendingInviteModal,
                    names: global.elements.pendingInviteModalChildNames,
                    multipleContributorContent: global.elements.multipleExistingPreviouslyInvited,
                    button: global.elements.pendingInviteModalSendAgain,
                }
            },
            dontSendInvite: {
                portfolios: activelyContributing,
                elements: {
                    modal: global.elements.activeContributorModal,
                    names: global.elements.activeContributorModalChildNames,
                    multipleContributorContent: global.elements.multipleExistingActivelyContributing,
                    button: global.elements.existingContributorModalContinue,
                }
            },
            sendNewInvite: {
                portfolios: [
                    ...previouslyContributed,
                    ...newlyInvited
                ],
                elements: {
                    modal: global.elements.inactiveContributorModal,
                    names: global.elements.inactiveContributorModalChildNames,
                    multipleContributorContent: global.elements.multipleExistingPreviouslyContributed,
                    button: global.elements.inactiveContributorModalSendAgain,
                }
            }
        };
        const amountUniqueScenarios = Object.values(scenariosMap).filter((scenario) => scenario.portfolios.length > 0).length;

        let action = _sendInvitesWithoutActiveContributionOnly;

        if (amountUniqueScenarios > 0) {
            action = amountUniqueScenarios === 1 ? () => _showSingularExistingContributorModal(scenariosMap) : () => _showMultipleExistingContributorsModal(scenariosMap);
        }

        if (amountUniqueScenarios === 1 && previouslyContributed.length === 0 && newlyInvited.length > 0) {
            action = _sendInvitesWithoutActiveContributionOnly;
        }

        return action();
    }

    function _showMultipleExistingContributorsModal (scenariosMap) {
        global.elements.existingContributorModalContributorName.innerHTML = global.elements.firstName.value;

        Object.values(scenariosMap).forEach((scenario) => {
            scenario.elements.names.forEach(element => element.innerHTML = _getCombinedChildNamesString(scenario.portfolios));
            scenario.elements.multipleContributorContent.hidden = scenario.portfolios.length === 0;
            scenario.elements.button.disabledProp = false;
        });

        global.elements.multipleExistingPlanSingular.hidden = scenariosMap.dontSendInvite.portfolios.length > 1;
        global.elements.multipleExistingPlanMultiple.hidden = scenariosMap.dontSendInvite.portfolios.length === 1;

        global.elements.existingContributorModal.open = true;
    }

    function _showSingularExistingContributorModal (scenariosMap) {
        Object.values(scenariosMap).forEach(scenario => {
            const scenarioIsPresent = scenario.portfolios.length > 0;

            if (scenarioIsPresent) {
                scenario.elements.names.forEach(element => element.innerHTML = _getCombinedChildNamesString(scenario.portfolios));
                scenario.elements.button.disabledProp = false;
                scenario.elements.modal.open = scenarioIsPresent;
            }
        });
    }

    function _getCombinedChildNamesString (portfolios = global.pageData.selectedPortfolios) {
        let formattedChildNames = '';

        portfolios.forEach((child, index) => {
            const isFirst = index === 0;
            const isLast = index === portfolios.length - 1;
            const isMultiple = portfolios.length > 1;

            const commaText = !isFirst && !isLast ? ', ' : '';
            const ampersandText = isMultiple && isLast ? ' & ' : '';

            let endText = '';

            if (isLast) {
                const childNameLastLetter = child.name.slice(-1);
                const nameEndsWithS = childNameLastLetter === 's' || childNameLastLetter === 'S';

                endText += nameEndsWithS ? '\' ' : '\'s ';
                endText += isMultiple ? 'Junior ISA\'s' :  'Junior ISA';
            }

            formattedChildNames += commaText + ampersandText + child.name + endText;
        });

        return formattedChildNames;
    }

    function _updateSelectedPortfolios () {
        global.pageData.selectedPortfolios = global.elements.jisaToggles
            .filter(toggle => toggle.activated)
            .map(toggle => {
                return {
                    name: toggle.getAttribute('data-child-name'),
                    portfolioId: toggle.getAttribute('data-jisa-id')
                };
            });
    }

    return { initialise };
})();